import { ArrowRight, CheckCircle2, Clock, Gem, Route } from "lucide-react";
import { money } from "../../lib/format";

interface MainQuestSummaryProps {
  currentProgress: string;
  nextStep: string;
  activationDepositAmount?: number | string | null;
  inviteUnlocked: boolean;
  gems: number;
  completedCount?: number;
  totalCount?: number;
  extraUnlocked?: string[];
}

export function MainQuestSummary({
  currentProgress,
  nextStep,
  activationDepositAmount,
  inviteUnlocked,
  gems,
  completedCount = 0,
  totalCount = 7,
  extraUnlocked = []
}: MainQuestSummaryProps) {
  const unlocked = [
    inviteUnlocked ? "邀友支線" : null,
    gems > 0 ? `寶石碎片 +${gems}` : null,
    ...extraUnlocked
  ].filter(Boolean);
  const nodes = Array.from({ length: totalCount }, (_, index) => index < completedCount);

  return (
    <section className="quest-summary quest-summary-feature" aria-label="新人七關主線任務">
      <div className="quest-summary-head">
        <span className="hero-kicker">主線任務</span>
        <h2>新人七關主線任務</h2>
        <strong className="quest-progress-count">
          {completedCount} / {totalCount}
        </strong>
      </div>
      <div className="quest-node-strip" aria-label={`主線進度 ${completedCount} / ${totalCount}`}>
        {nodes.map((done, index) => (
          <span
            aria-label={`第 ${index + 1} 關${done ? "已完成" : "未完成"}`}
            className={done ? "done" : ""}
            key={index}
            title={`第 ${index + 1} 關${done ? "已完成" : "未完成"}`}
          >
            <span className="visually-hidden">第 {index + 1} 關{done ? "已完成" : "未完成"}</span>
          </span>
        ))}
      </div>
      <div className="quest-summary-grid">
        <div>
          <Route size={18} />
          <span>目前主線</span>
          <strong>新人七關</strong>
        </div>
        <div>
          <CheckCircle2 size={18} />
          <span>目前進度</span>
          <strong>{currentProgress}</strong>
        </div>
        <div>
          <Clock size={18} />
          <span>下一步</span>
          <strong>{nextStep}</strong>
        </div>
        <div>
          <Gem size={18} />
          <span>入盟啟動筆</span>
          <strong>
            {activationDepositAmount ? `已選定 ${money(activationDepositAmount)}` : "等待後台選定"}
          </strong>
        </div>
      </div>
      <div className="unlock-list">
        <span>已解鎖</span>
        <strong>{unlocked.length ? unlocked.join(" / ") : "完成主線後逐步解鎖"}</strong>
      </div>
      <div className="quest-actions">
        <a className="primary-cta" href="/newbie">
          查看主線 <ArrowRight size={16} />
        </a>
        <a className="secondary-cta" href="/invite">
          查看邀友支線
        </a>
      </div>
    </section>
  );
}
